import Vue from 'vue';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';

import Toast from 'vue-toastification';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

import 'vue-toastification/dist/index.css';

import App from './App.vue';
import router from './router';
import setupHttp from './http';

Vue.config.productionTip = false;
Vue.use(Chartkick.use(Chart));

// Global API auth handling: redirect to login on 401 across all requests.
setupHttp(router);

Vue.use(Toast, { hideProgressBar: true });
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
